import * as React from "react"
import BaseController from '../base-controller';
import { graphql } from "gatsby"

// markup
class Blog extends React.Component {
  render() {
    const { allMdx } = this.props.data // data.markdownRemark holds your post data
    const {edges} = allMdx;
    console.log("edges",edges);
    return (
        <BaseController>
            <section class="space--sm">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="masonry masonry-blog-magazine">
                                <div class="masonry__container row masonry--active">
                                    {edges.map((edge)=>
                                        <div class="masonry__item col-md-4 col-12 filter-marketing" data-masonry-filter="Marketing">
                                            <a class="block" href={edge.node.frontmatter.slug}>
                                            <article class="feature feature-1">
                                            <a href={edge.node.frontmatter.slug} class="block">
                                                <img alt={edge.node.frontmatter.title} src={edge.node.frontmatter.image?.childImageSharp?.gatsbyImageData?.images?.fallback?.src} />
                                            </a>
                                            <div class="feature__body boxed boxed--border">
                                                <span>{edge.node.frontmatter.date}</span>
                                                <h5>{edge.node.frontmatter.title}</h5>
                                                <a href={edge.node.frontmatter.slug}>
                                                    Read More
                                                </a>
                                            </div>
                                        </article>
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </BaseController>
    )
  }
}


export const pageQuery = graphql`
query{
    allMdx(filter: {frontmatter: {contentType: {eq: "blog"}}}, sort: {order: DESC, fields: frontmatter___date}) {
      edges {
        node {
          frontmatter {
            slug
            title
            date
            description
            keywords
            date
            image {
                absolutePath
                base
                childImageSharp {
                  gatsbyImageData(
                    width: 800
                    blurredOptions: {width: 100}
                    placeholder: BLURRED
                    transformOptions: {cropFocus: CENTER}
                  )
                }
              }
          }
        }
      }
    }
  }
  `

export default Blog